import { render } from "./Definition.vue?vue&type=template&id=5e4eb299&scoped=true"
import script from "./Definition.vue?vue&type=script&lang=js"
export * from "./Definition.vue?vue&type=script&lang=js"

import "./Definition.vue?vue&type=style&index=0&id=5e4eb299&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e4eb299"]])

export default __exports__